

































































































































































































































































































import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator'
import { Customer } from '@/domain/Customer'
import { Prefectur } from '@/domain/Prefectur'
import PrefecturesService from '@/service/PrefecturesService'
import ZipService from '@/service/ZipService'

@Component
export default class CustomerDialogComponent extends Vue {
  prefecturesService = PrefecturesService.instance
  zipService = ZipService.instance

  @PropSync("value", { type: Boolean , default: false, required: false })
  dialog!: boolean

  @PropSync("default", { type: Customer, default: () => new Customer(), required: true })
  dto!: Customer

  @Prop({ default: true })
  isNew!: boolean

  /** バリデーション */
  invalid = false

  prefecturs: Prefectur[] = []
  
  /**
   * 初期実行
   */
  mounted() {
    /* 都道府県 */
    this.prefecturesService.findAll()
      .then(x => this.prefecturs = x)
  }

  /**
   * 初期化
   */
  reset() {
    this.dto = new Customer()
  }

  /**
   * 郵便番号検索
   */
  @Watch("dto.zipCode")
  changeZipCode() {
    const pattern = /^\d{3}-?\d{4}$/g
    if (!this.dto.zipCode.match(pattern) || this.dto.address1 !== "") return

    this.zipService.getAddress(this.dto.zipCode)
      .then(x => this.dto.address1 = x)
  }

  /**
   * 報告書添付ルールの変更
   */
  @Watch("dto.billingRule")
  changeBillingRule() {
    if (this.dto.billingRule === 1) {
      this.dto.deadline = 0
    } else if (this.dto.deadline === 0) {
      this.dto.deadline = 31
    }
  }

  /**
   * キャンセルボタンのクリック
   */  
  onCancel() {
    this.dialog = false
    this.reset()
  }

  /**
   * 確定のクリック
   */  
  onSubmit() {
    this.dialog = false
    this.$emit("input", this.dto)
    this.reset()
  }

}
